import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMemberStatusCancelledFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.3885 12.3863C12.2668 12.508 12.1068 12.5697 11.9468 12.5697C11.786 12.5697 11.6268 12.508 11.5043 12.3863L9.99933 10.8805L8.4985 12.3813C8.25433 12.6255 7.8585 12.6255 7.61433 12.3813C7.371 12.1372 7.371 11.7422 7.61433 11.498L9.11516 9.99717L7.6135 8.49467C7.36933 8.25051 7.36933 7.85551 7.6135 7.61134C7.85766 7.36717 8.25266 7.36717 8.49683 7.61134L9.9985 9.11301L11.5002 7.61217C11.7443 7.36801 12.1393 7.36801 12.3835 7.61217C12.6277 7.85551 12.6277 8.25134 12.3835 8.49551L10.8827 9.99717L12.3885 11.5022C12.6327 11.7463 12.6327 12.1422 12.3885 12.3863ZM10.0002 2.08301C5.63516 2.08301 2.0835 5.63384 2.0835 9.99967C2.0835 14.3647 5.63516 17.9163 10.0002 17.9163C14.3652 17.9163 17.9168 14.3647 17.9168 9.99967C17.9168 5.63384 14.3652 2.08301 10.0002 2.08301Z"
	})
});
export default SvgMemberStatusCancelledFill;
